import { adminApi } from "../utils/admin-api-axios";

export const getAllCategories = async () => {
  try {
    const response = await adminApi.getAllCategories();
    if (response.success) {
      return response;
    }
  } catch (error) {
    console.error("Error fetching categories:", error);
    return { success: false, error: error.message };
  }
};

export const createCategory = async (data) => {
  try {
    const response = await adminApi.createCategory(data);

    if (response.success) {
      return response;
    }
  } catch (error) {
    console.error("Error creating category:", error);
    return { success: false, error: error.message };
  }
};

export const updateCategory = async (id, data) => {
  try {
    const response = await adminApi.updateCategory(id, data);
    if (response && response.success) {
      return response;
    }
  } catch (error) {
    console.error("Error updating category:", error);
    return { success: false, error: error.message };
  }
};

export const deleteCategory = async (id) => {
  try {
    await adminApi.deleteCategory(id);

    console.log("Category deleted successfully");
  } catch (error) {
    console.error("Error deleting category:", error);
    return { success: false, error: error.message };
  }
};
